import React from 'react'
import Jumbotron from '../../components/Jumbotron/Jumbotron'
import Specialties from '../../components/Specialties/Specialties'
import Biography from '../../components/Biography/Biography'
import Calltoaction from '../../components/Calltoaction/Calltoaction'
// import Testimonials from '../../components/Testimonials/Testimonials'
import Contact from '../../components/Contact/Contact'
// import Statistics from '../../components/Statistics/Statistics'
import Presentation from '../../components/Presentation/Presentation'
const Inicio = () => {
  return (
    <div>
      <div id="jumbotron">
        <Jumbotron />
      </div>
      <div id="presentation">
        <Presentation/>
      </div>
      <div id="specialties">
        <Specialties/>
      </div>    
      {/* <div>
        <Statistics/>
      </div> */}
      <div id="bio">
        <Biography/>
      </div>
      <div id="cta">
        <Calltoaction/>
      </div>
      {/* <div>
        <Testimonials/>
      </div> */}
      <div id="contact">
        <Contact/>
      </div>
    </div>
  )
}

export default Inicio